import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-12 h-12 text-[#2C4F1A] animate-spin" />
          <p className="text-gray-500 font-medium font-bold uppercase tracking-widest text-[10px]">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar si el usuario tiene permiso por rol (si se especifica en la ruta)
  if (roles && !roles.includes(user.rol)) {
    return <Navigate to="/" replace />;
  }

  // Verificación de Permisos Dinámicos por Módulo
  // Obtenemos el nombre del módulo desde la ruta (ej: /cotizaciones -> cotizaciones)
  const path = location.pathname.split('/')[1];
  
  // Módulos que siempre están permitidos o no requieren permiso explícito (como el dashboard por defecto o el home)
  const whitelist = ['', 'dashboard'];
  
  if (path && !whitelist.includes(path)) {
    // Si el módulo no está en el array de permisos, bloqueamos
    const hasPermission = user.permisos?.includes(path);
    
    if (!hasPermission) {
      console.warn(`Acceso denegado al módulo: ${path}`);
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
